function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.03125,24.515625 C17.5234375,24.515625 17.921875,24.109375 17.921875,23.6484375 L17.921875,18.7578125 L22.6875,18.7578125 C23.1640625,18.7578125 23.5703125,18.359375 23.5703125,17.8671875 C23.5703125,17.3828125 23.1640625,16.9765625 22.6875,16.9765625 L17.921875,16.9765625 L17.921875,12.0859375 C17.921875,11.6171875 17.5234375,11.21875 17.03125,11.21875 C16.546875,11.21875 16.140625,11.6171875 16.140625,12.0859375 L16.140625,16.9765625 L11.375,16.9765625 C10.9140625,16.9765625 10.4921875,17.3828125 10.4921875,17.8671875 C10.4921875,18.359375 10.9140625,18.7578125 11.375,18.7578125 L16.140625,18.7578125 L16.140625,23.6484375 C16.140625,24.109375 16.546875,24.515625 17.03125,24.515625 Z",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}));

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.03cf0435.svg";
export { ForwardRef as ReactComponent };